import { NextPage } from 'next'
import { BlogHeader } from 'src/components/BlogHeader/BlogHeader'
import { CollectionCard } from 'src/components/CollectionCard/CollectionCard'
import { Footer } from 'src/components/Footer/Footer'
import { Breadcrumb } from 'src/components/global/Breadcrumb'
import MainContainer from 'src/components/global/MainContainer/MainContainer'
import { ThemeOnly } from 'src/components/global/ThemeOnly'
import { SHOW_COLLECTIONS_FOR_ALL } from 'src/config/config'
import { useGetCollectionsQuery } from 'src/graphql/generated/hooks'
import { Meta } from 'src/layout/Meta'
import { Main } from 'src/templates/Main'
import { getCollectionTab } from 'src/utils/collectionUtils'

import CollectionDesc from './CollectionDesc'

const Collections: NextPage = () => {
  const title = 'Collections'
  const description = 'Collections'
  const meta = <Meta title={title} description={description} url="/collections/" />
  const { data } = useGetCollectionsQuery()

  // Create a shallow copy of the collections array and sort by ID in descending order
  const sortedCollections = data?.collections?.slice().sort((a: any, b: any) => b.id - a.id)

  return (
    <Main meta={meta}>
      <MainContainer id="mainContainer" className={`${SHOW_COLLECTIONS_FOR_ALL == 'true' ? '' : 'bg-clouds'}`}>
        <div className={`conatiner flex flex-col ${SHOW_COLLECTIONS_FOR_ALL == 'true' ? 'bg-clouds' : ''}`}>
          {SHOW_COLLECTIONS_FOR_ALL == 'true' ? (
            <Breadcrumb subject="COLLECTIONS" className={'pr-1'} />
          ) : (
            <Breadcrumb subject="Collections" />
          )}
          <BlogHeader title="All Collections" />
          {SHOW_COLLECTIONS_FOR_ALL == 'true' ? <CollectionDesc /> : ''}
        </div>
        <div className="my-[65px]">
          <div className="w-full items-center justify-between">
            <div className="flex flex-col !max-w-[1080px] w-full px-5 sm:px-0 m-auto">
              <div className="grid md:grid-flow-row grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-[24px] gap-y-[46px]">
                {sortedCollections?.map(
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  (collection: any) =>
                    // collection.attributes.contents.data.length > 0 &&
                    SHOW_COLLECTIONS_FOR_ALL == 'true' ? (
                      <CollectionCard
                        key={collection.id} // Add a key prop for each CollectionCard
                        title={collection.name}
                        url={`/collections/${collection.slug}?tab=${getCollectionTab(collection)}`}
                        description={collection.description}
                        icon={collection?.iconName}
                      />
                    ) : (
                      <CollectionCard
                        key={collection.id} // Add a key prop for each CollectionCard
                        title={collection.name}
                        url={`/collections/${collection.slug}?tab=${getCollectionTab(collection)}`}
                        description={collection.description}
                      />
                    ),
                )}
              </div>
            </div>
          </div>
        </div>

        <ThemeOnly theme="legaltech">
          <Footer />
        </ThemeOnly>
      </MainContainer>
    </Main>
  )
}

export default Collections
